<template>
  <nav class="vw100 sticky top0 left0 zIndex3 column a-center bg-w">
    
    <div class="w-per100 column a-center bg-F7F7F7 ft14 font-Regular">
      <div class="w-per62_5 h30 row a-center j-sb">
        <span class="c-3 pointer" @click="toIndex">{{ $t('欢迎来到佰信纸业官网') }}</span>

        <!-- 官网 -->
        <!-- <div class="">
          <span class="c-9">{{ $t('您好') }}</span>
          <span class="c-3 ml37 pointer" @click="changeLanguage">{{ $t('语言') }}</span>
        </div> -->

        <!-- 商城 -->
        <div class="">
          <span class="c-9">{{ $t('您好') }}，</span>
          <span class="c-FF6000 pointer" v-if="!token" @click="toLogin">{{ $t('请登录') }}</span>
          <span class="c-FF6000 pointer" v-else @click="toCenter">{{ userInfo.username }}</span>
          <span class="c-3 ml22 pointer" v-if="!token" @click="toLogin">{{ $t('免费注册') }}</span>
          <span class="c-3 ml22 pointer" v-else @click="toOrder">{{ $t('我的订单') }}</span>
          <span class="c-3 ml37 pointer" @click="changeLanguage">{{ $t('语言') }}</span>
        </div>

      </div>
    </div>

    <div class="w-per100 column a-center" :class="current == -1?'bdb-F2F2F2':''">
      <div class="w-per62_5 row a-center j-sb">
        <img
          class="w50 h77 fit-cover mt31 mb34 pointer"
          referrerpolicy="no-referrer"
          :src="navInfo.logo"
          alt="佰信纸业"
          @click="toIndex"
        />
        <div class="w-per70 row j-end">
          <div class="flex1">
            <div class="w-per100 row">
              <div class="flex1 ft14 font-Regular">
                <el-input :placeholder="$t('搜索关键词')" v-model="keywords" clearable >
                  <i slot="prefix" class="el-input__icon el-icon-search c-434343"></i>
                </el-input>
              </div>
              <div class="w80">
                <el-popover
                  placement="bottom-end"
                  width="400"
                  trigger="click"
                >
                  <div class="w-per100 h200" style="overflow:auto">
                    <ul class="w-per100 h200" v-infinite-scroll="addPage">
                      <li v-for="(item,index) in dataList" :key="index" class="bdb-F2F2F2 p10 c-3 ft16 font-Regular pointer" @click.stop="toGoodsDetail(item)">{{ item.name }}</li>
                    </ul>
                  </div>
                  <div slot="reference" class="w80 h40 c-w ft14 font-Regular bg-FF8E29 row flex-center pointer" @click.stop="handleSearch">{{ $t('搜索') }}</div>
                </el-popover>
              </div>
            </div>
            <div class="w-per100 c-9 ft14 font-Regular my10 row" v-if="current == -1 || current == 8">
              <div class="">
                热门搜索
              </div>
              <div class="ml40 pointer" v-for="(item,index) in hot" :key="index" @click="handleInput(item)">
                {{ item }}
              </div>
            </div>
          </div>

          <!-- 商城 -->
          <div class="w170 h40 bd-EEEEEE row flex-center ml40 pointer" @click="toCart">
            <img
              class="wh15 fit-cover"
              referrerpolicy="no-referrer"
              :src="$getAssetUrl('/pcImgs/gouwuche.png')"
            />
            <span class="c-00903B ft14 font-Regular ml8">{{ $t('我的购物车') }}</span>
            <div class="ml8 wh20 row flex-center br-per50 bg-FF8E29 c-w ft14 font-Regular">
              {{navInfo.carNum}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-per100 h50 column a-center bg-00903B" v-if="current != -1">
      <div class="w-per62_5 h50 row a-center c-w ft16 font-Regular">
        <div class="flex1 h50 row flex-center pointer text-wrap text-center normal-break" :class="current==index?'bg-FF8E29':''" v-for="(item,index) in navInfo.navList" :key="index" @click="changeNav(item,index)">{{ item.name }}</div>
      </div>
    </div>
    
  </nav>
</template>
<!-- 切换说明 上面的备注官网和商城的地方切换，下面的setNavList，下面的toGoodsDetail跳转详情 -->
<script>
import { mapActions, mapGetters } from 'vuex';
import { getGoods,getCartList,getUserInfo } from "@/api/app";
export default {
  data() {
    return {
      hot:['热敏纸','打印纸'],
      keywords:'',
      dataList:[],
      page:1,
      last_page:0,
    }
  },
  props: {
    current: Number,
  },
  computed: {
    ...mapGetters({
      load_one:'computedLoad',
      navInfo:'computedNav',
      token:'computedToken',
      userInfo:'computedUserInfo',
      locale:'currentLocale',
    })
  },
  mounted() {
    if(this.load_one){
      this.setNavList();
      this._getConfig();
      this.getIndexBanner();
      this.getFourBanner();
      if(window.localStorage.getItem('token')){
        // console.log('111');
        this._getCartList();
        this._getUserInfo();
      }
    }
  },
  methods: {
    ...mapActions([
      'getFourBanner',
      'getIndexBanner',
      'changeCartNum',
      'changeInfo',
      'changeToken',
      'changeLocale',
      '_getConfig',
      '_getNavList',
    ]),
    // 回首页
    toIndex(){
      this.$router.push({
        path:'/'
      })
      window.scrollTo({
        behavior: "smooth",
        top: 0,
      })
    },
    handleInput(e){
      this.keywords = e;
    },
    // 设置导航栏
    setNavList(){
      // 官网
      let listIndex = [
        {name:this.$t('首页'),path:'/',},{name:this.$t('关于我们'),path:'/Intro',},
        {name:this.$t('产品中心'),path:'/Product',},{name:this.$t('工厂展示'),path:'/Factory',},
        {name:this.$t('销售网络'),path:'/Network',},{name:this.$t('服务支持'),path:'/Service',},
        {name:this.$t('新闻动态'),path:'/Enterprise',},{name:this.$t('联系我们'),path:'/Contact',},
        {name:this.$t('商城'),path:'/Mall',},
      ]
      // 商城
      let listShop = [
        {name:this.$t('商城'),path:'/',},
      ]
      let list = listIndex;
      // let list = listShop;
      this._getNavList(list);
    },
    // 跳转
    changeNav(item,index){
      // console.log(item,index);
      // 如果当前路由和点击的路由相同，不做任何操作
      if(this.$route.path == item.path){
        setTimeout(()=>{
          window.scrollTo({
            behavior: "smooth",
            top: 0,
          })
        },100)
        return ;
      }

      this.$router.push({
        path: item.path,
      })
    },
    toOrder(){
      this.$router.push({
        path: "/Orders",
      })
    },
    toCenter(){
      this.$router.push({
        path: "/Mine",
      })
    },
    toCart(){
      this.$router.push({
        path: "/Cart",
      })
    },
    toLogin(){
      this.$router.push({
        path: "/Login",
      })
    },
    // 去商品详情
    toGoodsDetail(item){
      // 官网
      // this.$router.push({
      //   path: "/PDetail",
      //   query:{
      //     // class_id:this.class_id,
      //     id:item.id,
      //   },
      // })

      // 商城
      this.$router.push({
        path: "/Goods",
        query:{
          id:item.id,
        },
      })
    },
    // 搜索
    handleSearch() {
      this.page = 1;
      this._getGoods();
    },
    // 搜索 翻页
    addPage(){
      if(this.page == this.last_page) return ;
      this.page++;
      this._getGoods();
    },
    // 切换语言
    changeLanguage() {
      let lang = window.localStorage.getItem('language') || 'en';
      // console.log('语言',lang);
      lang = lang == 'en'?'zh-CN':'en'
      window.localStorage.setItem('language',lang);
      this.changeLocale(lang);
      this.$i18n.locale = lang;
      

      // 根据语言切换路由
      let u = window.location.href;
      let r = u.slice(u.indexOf('#'));
      if(r=='/' || r=='/zh-CN'){
        if (lang === 'en') {
          this.$router.push('/'); // 英文版路由到 '/'
        } else {
          this.$router.push('/zh-CN'); // 中文版路由到 '/zh-CN'
        }
      }

      setTimeout(()=>{
        window.location.reload();
      },10)
    },
    // 购物车
    async _getCartList(){
      let params = {
        keywords:'',
      }
      const {data} = await getCartList(params);
      if(data.code == 1){
        let total = data.data.length;
        this.changeCartNum(total);
      }else{
        this.$message.error(data.msg);
      }
    },
    // 用户信息
    async _getUserInfo(){
      const {data} = await getUserInfo();
      if(data.code == 1){
        let info = data.data.userinfo;
        window.localStorage.setItem('token',info.token);
        window.localStorage.setItem('userinfo',JSON.stringify(info));

        this.changeToken(window.localStorage.getItem('token'));
        let userinfo = JSON.parse(window.localStorage.getItem('userinfo'));
        this.changeInfo(userinfo);
      }else{
        this.$message.error(data.msg);
      }
    },
    // 商品列表
    async _getGoods(){
      let params = {
        keywords:this.keywords,
        category_id1:0,
        category_id:0,
        is_rec:0,
        order:'total_volume desc',
        page:this.page,
        per_page:6,
      }
      const {data} = await getGoods(params);
      if(data.code == 1){
        this.last_page = data.data.last_page;
        if(this.page == 1){
          this.dataList = data.data.data;
        }else{
          let temp = this.dataList;
          let temp1 = data.data.data;
          if(temp1.length>0){
            this.dataList = [...temp,...temp1];
          }
        }
      }else{
        this.$message.error(data.msg);
      }
    },
  },
}
</script>

<style scoped lang="scss">
nav{
  ::v-deep .el-input{
    .el-input__inner{
      border: 1px solid #FF8E29;
      border-radius: 0;
      color: #333333;
      height: 2.0833vw;
      line-height: 2.0833vw;
      padding: 0 0.78125vw;
      padding-left: 2.5vw;
    }
    .el-input__prefix{
      left: 0.5208vw;
      .el-input__icon{
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1250px){
nav{
  ::v-deep .el-input{
    .el-input__inner{
      height:  4.1667vw;
      line-height: 4.1667vw;
      padding: 0 0.78125vw;
      padding-left: 3.125vw;
    }
    .el-input__prefix{
      left: 0.46875vw;
    }
  }
}
}
@media screen and (max-width: 750px){
nav{
  .h30{height: 20px;}
  .my10{
    margin-top: 4px;
    margin-bottom: 4px;
  }
  .h77 {height: 8.0208vw;}
  .w50 {width: 5.2083vw;}
  .mb34 {margin-bottom: 10px;}
  .mt31 {margin-top: 10px;}
  ::v-deep .el-input{
    font-size: 6px;
    .el-input__inner{
      height:  4.1667vw;
      line-height: 4.1667vw;
      padding: 0 1.1719vw;
      padding-left: 3.75vw;
    }
    .el-input__prefix{
      left: 0.75vw;
      .el-input__icon{
        width: 15px;
      }
    }
  }
}
}
</style>
